import { motion } from 'motion/react';
import {
  indicatorContainer,
  indicatorPill,
  indicatorIconPurple,
  indicatorIconTeal,
  indicatorIconAmber,
  indicatorIconRed,
} from './chatViewTheme';

const ICON_CLASS = {
  default: indicatorIconPurple,
  purple: indicatorIconPurple,
  amber: indicatorIconAmber,
  red: indicatorIconRed,
  green: indicatorIconTeal,
};

export default function GenericIndicator({
  icon: Icon,
  label,
  sublabel,
  variant = 'default',
  reduceMotion,
  action,
}: any) {
  const iconClass = ICON_CLASS[variant] || indicatorIconPurple;

  return (
    <motion.div
      layout={reduceMotion ? false : undefined}
      initial={reduceMotion ? false : { opacity: 0, y: -4 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.2 }}
      className={indicatorContainer}
      aria-label={label}
    >
      <div className={`${indicatorPill} ${sublabel ? 'max-w-[85%] flex-col items-start gap-1 py-2' : ''}`}>
        <div className={`flex items-center gap-2 ${sublabel ? 'w-full' : ''}`}>
          {Icon && <Icon className={iconClass} aria-hidden />}
          <span className="text-[11px] font-medium">{label}</span>
          {action && !sublabel && (
            <button
              type="button"
              onClick={action.onClick}
              className="ml-1 text-[11px] font-semibold underline underline-offset-2 hover:opacity-80"
            >
              {action.label}
            </button>
          )}
        </div>
        {sublabel && <p className="text-[10px] leading-snug opacity-80 pl-6">{sublabel}</p>}
        {action && sublabel && (
          <button
            type="button"
            onClick={action.onClick}
            className="pl-6 text-[11px] font-semibold underline underline-offset-2 hover:opacity-80"
          >
            {action.label}
          </button>
        )}
      </div>
    </motion.div>
  );
}
